<template>
  <div id="app">
    <header id="header">
      <router-link to="/" @click.native="hideMenu">
      <img id="logo" src="./assets/image/logo.svg" width="100" alt="tnyu">
      </router-link>
      
      <nav id="menu" :class="{active:showMenu}">
        <ul>
        <li><router-link to="/about" @click.native="hideMenu">ABOUT</router-link></li>
        <li><router-link to="/work" @click.native="hideMenu">WORK</router-link></li>
        </ul>
      </nav>
      <button id="menu-button" 
        @click="showMenu = !showMenu" 
        :class="{active:showMenu}"
        aria-label="Toggle menu"
        >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </header>
    <main>
      <router-view/>
    </main>
    <footer id="footer" v-show="$store.state.pageReady">
      <img id="emblem" src="./assets/image/emblem.svg" width="150" alt="tnyu emblem">
      <ul id="footer-links" v-if="$store.state.siteInfoLoaded">
        <li><a :href="'mailto:'+contactEmail" class="bracket">{{contactEmail}}</a></li>
        <li v-for="link in siteInfo['sns-links']" :key="link.name">
          <a :href="link.url" class="bracket" target="_blank">{{link.name}}</a>
        </li>
      </ul>
      <div class="copyright">© tnyu inc.</div>
    </footer>
  </div>
</template>

<script>
import 'lazysizes'
import SiteInfo from '@/mixins/SiteInfo'
import PageData from '@/mixins/PageData'

import 'normalize.css';
import '@/assets/style/base.scss';
import '@/assets/style/large.scss';
import '@/assets/style/wp/style.min.css'

import '@/assets/image/og.jpg'

export default {
  name: 'App',
  mixins:[PageData,SiteInfo],
  data:()=>({
    showMenu:false
  }),
  mounted(){
    this.getSiteInfo(this.name).then(()=>{
      // console.log(this.siteInfo['sns-links'])
    })
  },
  methods:{
    hideMenu(){
      this.showMenu = false
    }
  }
}
</script>